export const ServiceProviderTypeEnum = {
  /** 三方 Sass 服务商 1 */
  THIRD_PARTY_SASS: "1",
  /** 三方接包服务商 2 */
  THIRD_PARTY_CONTRACTOR: "2",
  /** 总包服务商 3 */
  GENERAL_CONTRACTOR: "3",
};

export const ServiceProviderTypeEnumMap = {
  [ServiceProviderTypeEnum.THIRD_PARTY_SASS]: "三方Sass服务商",
  [ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR]: "三方接包服务商",
  [ServiceProviderTypeEnum.GENERAL_CONTRACTOR]: "总包服务商",
};

export const ServiceProviderTypeEnumList = [
  {
    value: ServiceProviderTypeEnum.THIRD_PARTY_SASS,
    text: ServiceProviderTypeEnumMap[ServiceProviderTypeEnum.THIRD_PARTY_SASS],
  },
  {
    value: ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR,
    text: ServiceProviderTypeEnumMap[
      ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR
    ],
  },
  {
    value: ServiceProviderTypeEnum.GENERAL_CONTRACTOR,
    text: ServiceProviderTypeEnumMap[
      ServiceProviderTypeEnum.GENERAL_CONTRACTOR
    ],
  },
];

export default {
  data() {
    return {
      Mixins_tenantDetail: {},
    };
  },
  methods: {
    // 获取企业明细
    Mixins_getServiceProviderType() {
      const url = `/${serverConfig.msCustomerService}/tenant/data/get-tenant-detail?guid=${localStorage.guid}`;
      return this.api.get(url).then((res) => {
        const { data } = res;
        if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.Mixins_tenantDetail = data.data;
        } else {
          this.$message.error(data.msg);
        }
        return data.data;
      });
    },
  },
};
